<script setup>
import {defineProps} from 'vue'
const props = defineProps(["data"])
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import QueryRunner from '@/views/Authenticated/Query/Runner.vue'

import { useMainStore } from '@/stores/main'
let mainStore = useMainStore()

function a() {
  mainStore.show_slideover(QueryRunner, { input: [props.data], type: "fingerprint_ips" }, { width: 10 }, "(ips) " +props.data) 
}

</script>

<template>
  <div class="d-flex">
    <span>{{ data }}</span>
    <span class="b ms-auto" @click="a">
     <font-awesome-icon style="font-size: 1rem;" :icon="['fas', 'square-up-right']" />
    </span>
  </div>
</template>

<style scoped>
.b {
  color: #4b5563;
}

.b:hover {
  color: white;
}
</style>
